var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons/faExternalLink';
var style = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  &:visited {\n    color: ", ";\n  }\n\n  &:hover {\n    color: ", ";\n    &:focus {\n      box-shadow: 0 0 0 2px ", ";\n    }\n  }\n\n  &:active,\n  &:active:focus {\n    color: ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px ", ";\n    outline: 0;\n  }\n"], ["\n  color: ", ";\n  &:visited {\n    color: ", ";\n  }\n\n  &:hover {\n    color: ", ";\n    &:focus {\n      box-shadow: 0 0 0 2px ", ";\n    }\n  }\n\n  &:active,\n  &:active:focus {\n    color: ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px ", ";\n    outline: 0;\n  }\n"])), function (p) {
  return p.theme.secondary;
}, function (p) {
  return p.theme.colorLevel(p.theme.secondary, 1);
}, function (p) {
  return p.theme.secondary;
}, function (p) {
  return p.theme.colorLevel(p.theme.secondary, -5);
}, function (p) {
  return p.theme.colorLevel(p.theme.secondary, 1);
}, function (p) {
  return p.theme.colorLevel(p.theme.secondary, -5);
});
var StyledLink = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), style);
var StyledA = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), style); // TODO: link that looks like a button

var FiduciusLink = function FiduciusLink(_a) {
  var children = _a.children,
      _b = _a.external,
      external = _b === void 0 ? false : _b,
      _c = _a.icon,
      icon = _c === void 0 ? false : _c,
      to = _a.to;

  if (external) {
    return React.createElement(StyledA, {
      href: to
    }, children, icon && React.createElement(FontAwesomeIcon, {
      icon: faExternalLink,
      fixedWidth: true,
      size: "xs",
      transform: "shrink-6 up-3 left-1"
    }));
  } else {
    return React.createElement(StyledLink, {
      to: to
    }, children);
  }
};

export default FiduciusLink;
var templateObject_1, templateObject_2, templateObject_3;